<template>
	<sky-charts
		:api-conf="apiConf"
		ref="chart"
		:queryCondition="condition"
		:config="chartConfig"
		:extend="extend"
	>
	</sky-charts>
</template>

<script>
import apiConf from '@/backend/apiConfig/apiConfig';
import weburlSelect from '@/components/website/weburlSelect.js';
export default {
	name: 'ga_channel',
	// mixins: [mixins],
	props: {
		condition: {
			required: false,
		},
	},
	data() {
		return {
			apiConf: null,
			chartConfig: {
				name: '渠道分析',
				type: 'veHistogram',
				columns: [],
				chartSettings: {
					labelMap: {},
					// 堆叠
					stack: {
						result: [],
					},
				},
			},
			extend: {
				tooltip: {
					formatter: function formatter(maps) {
						let tpl = [`${maps[0].name}<br/>`];
						maps
							.sort((a, b) => {
								return b.value - a.value;
							})
							.forEach(item => {
								let { value, seriesName, marker } = item;
								tpl.push(`${marker}${seriesName}：${value}<br/>`);
							});

						return tpl.join('');
					},
				},
			},
			data: {},
		};
	},
	watch: {
		condition: {
			handler(val) {
				// if (val.customerId) {
				// 	this.$nextTick(() => {
				// 		this.$refs.chart && this.$refs.chart.initCharts();
				// 	});
				// }
				this.apiConf = {
					api: apiConf.website['get' + weburlSelect(val.status) + 'ChannelReport'],
          config: {
						timeout: 60000,
					},
				};

				this.chartConfig.chartSettings.labelMap = this.labelMap(val.status, 'labelMap')[0];
				this.chartConfig.columns = this.labelMap(val.status, 'labelMap')[1];
				this.chartConfig.chartSettings.stack.result = this.labelMap(val.status, 'stack');
			},
			deep: true,
		},
	},
	methods: {
		labelMap(status, type) {
			let objGA = {
				directNum: '直接进入',
				organicSearchNum: '自然搜索',
				paidSocialNum: '付费社媒',
				organicSocialNum: '自然社媒',
				referralNum: '外部跳转',
				paidSearchNum: '付费搜索',
				paidVideoNum: '付费视频',
				displayNum: '展示广告',
				crossNetworkNum: '跨网广告',
				unassignedNum: '暂未分类',
			};
			let objBd = {
				referralNum: '外部链接',
				directNum: '直接访问',
				displayNum: '搜索引擎',
			};

			let columnsGA = [
				'showTimeStr',
				'directNum',
				'organicSearchNum',
				'paidSocialNum',
				'organicSocialNum',
				'referralNum',
				'paidSearchNum',
				'paidVideoNum',
				'displayNum',
				'crossNetworkNum',
				'unassignedNum',
			];
			let columnsBd = ['showTimeStr', 'referralNum', 'directNum', 'displayNum'];

			let value = status === 1 ? objGA : status === 2 ? objBd : '';
			let columns = status === 1 ? columnsGA : status === 2 ? columnsBd : '';
			let arr = Object.keys(value);

			return type === 'labelMap' ? [value, columns] : arr;
		},
	},
};
</script>

<style scoped></style>
